import { render, staticRenderFns } from "./HeadlessBannersEdit.vue?vue&type=template&id=13ec4768&"
import script from "./HeadlessBannersEdit.vue?vue&type=script&lang=ts&"
export * from "./HeadlessBannersEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports